module.exports = new __parcel__URL__("website-troubleshooting.3adaeebb.svg").toString();